import React from 'react';

import { motesToCSPR } from '../../utils/currency';
import { currencyPrecisionByCase, PrecisionCase } from '../../utils/currency';
import CurrencyAmount from '../currency-amount/currency-amount';

export interface CsprProps {
  motes?: string | number | null;
  precisionCase?: PrecisionCase;
  hideCsprCurrency?: boolean;
}

export function Cspr({ motes, precisionCase, hideCsprCurrency }: CsprProps) {
  const precision = currencyPrecisionByCase(precisionCase);

  if (motes == null) {
    return <>{'N/A'}</>;
  }

  const csprAmount = motesToCSPR(motes.toString());

  return (
    <CurrencyAmount
      amount={csprAmount}
      symbol={hideCsprCurrency ? undefined : 'CSPR'}
      precision={precision}
    />
  );
}

export default Cspr;
